exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: inline-block;\n}\n\n.logo {\n  width: 100%;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/viega-common/components/viega-logo/viega-logo.component.scss
// module id = 2xv8
// module chunks = 5